export const isFtp = (type: unknown) => type === 'ftp' || type === 'sftp';
